module.exports = __webpack_public_path__ + "img/infoimg.5a7eb937.png";